import React from "react";
import { Link } from "react-router-dom";
import Header from "../components/Header";
import HeroSection from "../components/HeroSection";
import ServiceHighlights from "../components/ServiceHighlights";
import ServicesOverview from "../components/ServicesOverview";
import FAQ from "../components/FAQ";
import Footer from "../components/Footer";
import PartnerMarquee from "../components/PartnerMarquee";
import HelpButton from "../components/HelpButton";
import { Reviews } from "../components/Reviews";
import SEO from "../components/SEO";
import { generateServiceSchema } from "../lib/schema";
import { Check } from "lucide-react";
import LaadpaalFAQ from "../components/faqs/LaadpaalFAQ";

function Laadpaal() {
  return (
    <div className="min-h-screen bg-gray-50 page-transition pt-[99px] md:pt-[133px]">
      <SEO
        title="Laadpaal installatie - Elektraaanleggen.nl"
        description="Laat uw laadpaal vakkundig installeren door onze gecertificeerde elektriciens. Veilig en toekomstbestendig laden aan huis. Ideaal voor elektrische voertuigen."
        schema={generateServiceSchema({
          name: "Laadpaal Installatie",
          description:
            "Onze gecertificeerde elektriciens installeren laadpalen voor elektrische voertuigen, veilig en toekomstbestendig. Geniet van het gemak van thuisladen met een professionele installatie.",
          image: "https://elektraaanleggen.nl/images/banner.png",
        })}
      />

      <Header />
      <HeroSection
        title="Laadpaal installatie"
        description="Laat uw laadpaal vakkundig installeren door onze gecertificeerde elektriciens. Veilig en toekomstbestendig laden aan huis."
        imageSrc="/images/wallbox.png"
      />

      {/* Features Section */}
      <section className="mx-auto w-[calc(100%-2.5rem)] max-w-[1260px] mb-12 md:mb-16">
        <div className="grid items-center w-full gap-12 grid-cols-1 md:grid-cols-2 mb-16 md:mb-20 xl:mb-20">
          <div className="[&_p]:!text-[#17354A] [&_p]:text-base md:[&_p]:text-lg order-2 md:order-none">
            <h2 className="font-bold text-black leading-[1.25] text-[24px] lg:text-[36px] text-[#17354A] mb-4 md:mb-6">
              Professionele laadpaal installatie voor uw elektrische auto
            </h2>
            <p>
              Bent u op zoek naar een betrouwbare laadpaalinstallatie voor uw
              elektrische auto? Bij Elektra Aanleggen begrijpen we het belang
              van een veilige en efficiënte laadoplossing aan huis. Onze
              gecertificeerde elektriciens verzorgen de volledige installatie,
              inclusief eventuele aanpassingen aan uw meterkast, zodat u
              zorgeloos kunt opladen.​
            </p>
            <br></br>
            <p>Waarom kiezen voor Elektra Aanleggen?</p>
            <br></br>

            <ul className="space-y-3 mb-6">
              <li className="flex items-center gap-2">
                <Check className="w-5 h-5 text-[#F47B20]" />
                <span className="text-[#17354A]">
                  Ervaring met alle gangbare merken: Of u nu kiest voor een
                  EVBox, Wallbox, of een ander merk, wij hebben de expertise om
                  deze vakkundig te installeren.​
                </span>
              </li>
              <li className="flex items-center gap-2">
                <Check className="w-5 h-5 text-[#F47B20]" />
                <span className="text-[#17354A]">
                  Veilige installatie volgens NEN 1010 normen: Uw veiligheid
                  staat voorop. Daarom werken wij strikt volgens de laatste NEN
                  1010 normen en gebruiken we hoogwaardige materialen.​
                </span>
              </li>
              <li className="flex items-center gap-2">
                <Check className="w-5 h-5 text-[#F47B20]" />
                <span className="text-[#17354A]">
                  Advies op maat: Wij bieden persoonlijk advies om de beste
                  laadoplossing voor uw situatie te bepalen, rekening houdend
                  met uw huidige en toekomstige energiebehoeften.
                </span>
              </li>
            </ul>
            <br></br>
            <p>Neem contact op voor een vrijblijvende offerte</p>
            <br></br>
            <p>
              Wilt u meer weten over onze laadpaalinstallaties of een
              vrijblijvende offerte ontvangen? Neem dan contact met ons op. Ons
              team staat klaar om u te voorzien van deskundig advies en een
              oplossing die perfect aansluit bij uw wensen.
            </p>
            <div className="h-9"></div>
            <Link
              to="/offerte"
              aria-label="Vraag een vrijblijvende offerte aan voor groepenkast vervanging"
              className="relative font-medium transition-all duration-150 leading-normal outline-none inline-flex border-2 border-transparent items-center justify-center rounded-full active:scale-[.98] disabled:cursor-not-allowed text-base px-5 h-12 leading-[48px] bg-[#F47B20] text-white hover:bg-[#F47B20]/80 focus:bg-[#F47B20]/80 focus-visible:border-crustaLight disabled:bg-[#F47B20]/40 w-full md:w-fit"
              style={{ minWidth: "216px" }}
            >
              <span className="flex items-center gap-1">Gratis offerte</span>
            </Link>
          </div>
          <div className="order-1 md:-order-1">
            <div className="relative">
              <img
                alt="Laadpaal installatie"
                loading="lazy"
                className="rounded-lg w-full h-auto"
                src="/images/wallbox.jpeg"
              />
            </div>
          </div>
        </div>

        <div className="grid items-center w-full gap-12 grid-cols-1 md:grid-cols-2 mb-16 md:mb-20 xl:mb-20">
          <div className="[&_p]:!text-[#17354A] [&_p]:text-base md:[&_p]:text-lg order-2 md:order-2">
            <h2 className="font-bold text-black leading-[1.25] text-[24px] lg:text-[36px] text-[#17354A] mb-4 md:mb-6">
              Professionele laadpaal installatie met Zaptec en Wallbox
            </h2>
            <p>
              Bent u op zoek naar een betrouwbare laadpaal voor uw elektrische
              auto? Bij Elektra Aanleggen installeren wij laadstations van
              Zaptec en Wallbox, twee van de meest geavanceerde en efficiënte
              merken op de markt. Onze gecertificeerde elektriciens zorgen voor
              een veilige en vakkundige installatie, inclusief eventuele
              aanpassingen aan uw meterkast, zodat u altijd verzekerd bent van
              een betrouwbare en snelle laadoplossing.
            </p>
            <br></br>
            <p>Waarom kiezen voor Zaptec en Wallbox?</p>
            <br></br>

            <ul className="space-y-3 mb-6">
              <li className="flex items-center gap-2">
                <Check className="w-5 h-5 text-[#F47B20]" />
                <span className="text-[#17354A]">
                  Zaptec laadpalen – Slimme, compacte en uiterst efficiënte
                  laadoplossingen. Deze Scandinavische laadpalen staan bekend om
                  hun intelligente energiebeheer, waardoor uw auto altijd zo
                  snel mogelijk oplaadt zonder uw woning te overbelasten.
                  Bovendien zijn de laadstations geschikt voor zowel 1-fase als
                  3-fase aansluitingen en kunnen ze eenvoudig worden
                  geïntegreerd met zonnepanelen en dynamische laadsystemen.
                </span>
              </li>
              <li className="flex items-center gap-2">
                <Check className="w-5 h-5 text-[#F47B20]" />
                <span className="text-[#17354A]">
                  Wallbox laadpalen – Innovatief en krachtig. Wallbox biedt
                  gebruiksvriendelijke laadstations, ideaal voor zowel thuis als
                  zakelijke toepassingen. Dankzij slimme functies zoals
                  energieverdeling, wifi-connectiviteit en app-bediening heeft u
                  volledige controle over uw laadsessie. Wallbox-laders zijn
                  bovendien compatibel met elk type elektrische auto en kunnen
                  worden gekoppeld aan zonnepanelen of andere duurzame
                  energiebronnen.
                </span>
              </li>
            </ul>
            <br></br>
            <p>Waarom Elektra Aanleggen voor uw laadpaal installatie?</p>
            <br></br>
            <ul className="space-y-3 mb-6">
              <li className="flex items-center gap-2">
                <Check className="w-5 h-5 text-[#F47B20]" />
                <span className="text-[#17354A]">
                  Veilige installatie volgens NEN 1010-normen
                </span>
              </li>
              <li className="flex items-center gap-2">
                <Check className="w-5 h-5 text-[#F47B20]" />
                <span className="text-[#17354A]">
                  Volledige integratie met uw meterkast en energiebeheer
                </span>
              </li>
              <li className="flex items-center gap-2">
                <Check className="w-5 h-5 text-[#F47B20]" />
                <span className="text-[#17354A]">
                  Maatwerkadvies voor de beste laadoplossing bij uw situatie
                </span>
              </li>
              <li className="flex items-center gap-2">
                <Check className="w-5 h-5 text-[#F47B20]" />
                <span className="text-[#17354A]">
                  Ervaring met zowel 1-fase als 3-fase laadpaal installaties
                </span>
              </li>
              <li className="flex items-center gap-2">
                <Check className="w-5 h-5 text-[#F47B20]" />
                <span className="text-[#17354A]">
                  Duurzame opties zoals koppeling met zonnepanelen
                </span>
              </li>
            </ul>
            <br></br>
            <p>
              Wilt u een Zaptec of Wallbox laadpaal laten installeren? Neem
              vandaag nog contact met ons op voor een vrijblijvende offerte en
              deskundig advies!
            </p>
            <div className="h-9"></div>
            <Link
              to="/offerte"
              aria-label="Vraag een vrijblijvende offerte aan voor groepenkast vervanging"
              className="relative font-medium transition-all duration-150 leading-normal outline-none inline-flex border-2 border-transparent items-center justify-center rounded-full active:scale-[.98] disabled:cursor-not-allowed text-base px-5 h-12 leading-[48px] bg-[#F47B20] text-white hover:bg-[#F47B20]/80 focus:bg-[#F47B20]/80 focus-visible:border-crustaLight disabled:bg-[#F47B20]/40 w-full md:w-fit"
              style={{ minWidth: "216px" }}
            >
              <span className="flex items-center gap-1">Gratis offerte</span>
            </Link>
          </div>
          <div className="order-1 md:order-2">
            <div className="relative">
              <img
                alt="Laadpaal installatie"
                loading="lazy"
                className="rounded-lg w-full h-auto"
                src="/images/zaptec-pro-22-kw-mid-inclusief-backplate-bidirectional-ready-864010.webp"
              />
            </div>
          </div>
        </div>

        <div className="grid items-center w-full gap-12 grid-cols-1 md:grid-cols-2 mb-16 md:mb-20 xl:mb-20">
          <div className="[&_p]:!text-[#17354A] [&_p]:text-base md:[&_p]:text-lg order-2 md:order-none">
            <h2 className="font-bold text-black leading-[1.25] text-[24px] lg:text-[36px] text-[#17354A] mb-4 md:mb-6">
              Kwaliteitsgarantie & Transparante Prijs voor Laadpaal Installatie
            </h2>
            <p>
              Bij Elektra Aanleggen bent u verzekerd van een veilige en
              professionele laadpaal installatie. Wij werken uitsluitend met
              erkende elektriciens en installeren laadpalen van A-merken zoals
              Zaptec en Wallbox, volledig volgens de NEN 1010-normen.
            </p>
            <br></br>
            <p>
              Duidelijke prijs vooraf – U ontvangt altijd een transparante
              offerte zonder verborgen kosten. Voor standaard installaties
              kunnen wij telefonisch of via foto’s een prijsindicatie geven. Bij
              complexere situaties komen we langs voor een vrijblijvende
              inspectie.
            </p>
            <br></br>

            <ul className="space-y-3 mb-6">
              <li className="flex items-center gap-2">
                <Check className="w-5 h-5 text-[#F47B20]" />
                <span className="text-[#17354A]">
                  Garantie op installatie en materialen
                </span>
              </li>
              <li className="flex items-center gap-2">
                <Check className="w-5 h-5 text-[#F47B20]" />
                <span className="text-[#17354A]">
                  Veilige aansluiting op uw meterkast
                </span>
              </li>
              <li className="flex items-center gap-2">
                <Check className="w-5 h-5 text-[#F47B20]" />
                <span className="text-[#17354A]">
                  Geschikt voor 1-fase & 3-fase laadpalen
                </span>
              </li>
            </ul>

            <div className="h-9"></div>
            <Link
              to="/offerte"
              aria-label="Vraag een vrijblijvende offerte aan voor groepenkast vervanging"
              className="relative font-medium transition-all duration-150 leading-normal outline-none inline-flex border-2 border-transparent items-center justify-center rounded-full active:scale-[.98] disabled:cursor-not-allowed text-base px-5 h-12 leading-[48px] bg-[#F47B20] text-white hover:bg-[#F47B20]/80 focus:bg-[#F47B20]/80 focus-visible:border-crustaLight disabled:bg-[#F47B20]/40 w-full md:w-fit"
              style={{ minWidth: "216px" }}
            >
              <span className="flex items-center gap-1">Gratis offerte</span>
            </Link>
          </div>
          <div className="order-1 md:-order-1">
            <div className="relative">
              <img
                alt="Laadpaal installatie"
                loading="lazy"
                className="rounded-lg w-full h-auto"
                src="/images/7dfdea4e2c3379ee082654a0e871-high.webp"
              />
            </div>
          </div>
        </div>
      </section>

      <ServicesOverview />
      <LaadpaalFAQ />

      <ServiceHighlights />

      <Reviews />

      <PartnerMarquee />

      {/* CTA Section */}
      <div className="w-full cursor-pointer bg-[#2FB6D2] transition-opacity duration-150 hover:opacity-80">
        <Link
          to="/offerte"
          aria-label="Vraag een vrijblijvende offerte aan voor groepenkast vervanging"
        >
          <section className="mx-auto w-[calc(100%-2.5rem)] max-w-[1260px] text-center py-6 justify-between items-center">
            <div
              data-variant="h2"
              className="font-bold leading-[1.25] text-[28px] lg:text-[36px] self-center text-white mb-0"
            >
              Gratis offerte
            </div>
          </section>
        </Link>
      </div>

      <HelpButton />
      <Footer />
    </div>
  );
}

export default Laadpaal;
